"use client";
import { ISiteConfig } from "./interfaces/site-config";

export let siteConfig: ISiteConfig;

export function setClientSiteConfig(config: ISiteConfig) {
  siteConfig = config;
}

export function getClientSiteConfig(): ISiteConfig {
  return siteConfig;
}
